const TablePageList =['10', '20', '50', '100', '200'];

export default TablePageList